import React from 'react'
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'
import { AcceptSource, ConsentDocument } from 'src/graphql.generated'

const CONSENT_SOURCE_TEXT: Record<AcceptSource, string> = {
  [AcceptSource.Verbal]: 'Consented verbally on',
  [AcceptSource.App]: 'Consented via app on',
  [AcceptSource.Web]: 'Consented via web on',
}

interface Props {
  consentDocuments: ConsentDocument[]
}

const formatDateTime = (date: Date) => ({
  date: date.toLocaleDateString(),
  time: date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }),
})

const TermsSection = ({ consentDocuments }: Props) => {
  const areAllTermsAccepted = consentDocuments.every((doc) => doc.acceptedAt)
  const earliestAcceptanceDate = consentDocuments
    .map((doc) => doc.acceptedAt)
    .filter((date): date is Date => date !== null)
    .sort((a, b) => a.getTime() - b.getTime())[0]

  return (
    <div>
      {areAllTermsAccepted && earliestAcceptanceDate && (
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
          Participant reviewed and consented the following documents:
        </Typography>
      )}

      <Box display="flex" flexDirection="column" gap={1}>
        {consentDocuments.map((doc) => (
          <FormControlLabel
            key={doc.id}
            control={<Checkbox checked={!!doc.acceptedAt} disabled />}
            label={
              <Box display="flex" flexDirection="column">
                <Typography>{doc.title}</Typography>
                {doc.acceptedAt && (
                  <Typography variant="caption" color="text.secondary">
                    {doc.acceptSource ? CONSENT_SOURCE_TEXT[doc.acceptSource] : 'Consented on '}{' '}
                    {formatDateTime(doc.acceptedAt).date} at {formatDateTime(doc.acceptedAt).time}
                  </Typography>
                )}
              </Box>
            }
          />
        ))}
      </Box>
    </div>
  )
}

export default TermsSection
